import { render, staticRenderFns } from "./ScrollPage.vue?vue&type=template&id=1373b55d&scoped=true&"
import script from "./ScrollPage.vue?vue&type=script&lang=js&"
export * from "./ScrollPage.vue?vue&type=script&lang=js&"
import style0 from "./ScrollPage.vue?vue&type=style&index=0&id=1373b55d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373b55d",
  null
  
)

export default component.exports